<div class="inicio">
  <p class="titulo"> SEGUIMIENTO DE SERVICIOS DADOS DE ALTA </p>

  <!--TABLA CON LOS DATOS -->
  <div class="div">

    <!--Barra de búsqueda-->
    <div class="grid-container2">
      <mat-form-field>
        <mat-label>BUSCAR</mat-label>
        <input matInput debounceInput [debounceTime]="500" (onEventDebounce)="applyFilter($event)"
          placeholder="INGRESE DATO A BUSCAR">
      </mat-form-field>

    </div>

    <!--Tabla-->
    <mat-progress-bar *ngIf="expression" mode="indeterminate"></mat-progress-bar>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="descargarResp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> VER/DESCARGAR RESPONSIVA </th>
        <td mat-cell *matCellDef="let element">
          <button mat-mini-fab matTooltip="Descargar responsiva" style="background-color: #0804e9;"
            (click)="descargarResponsiva(element.id_solicitud)" [disabled]="cargando">
            <span class="material-icons">visibility</span>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="subirResp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> SUBIR RESPONSIVA FIRMADA </th>
        <td mat-cell *matCellDef="let element">
          <button mat-mini-fab matTooltip="Subir responsiva firmada" style="background-color: #2ae904;"
            [disabled]="cargando" (click)="subirResponsiva(element.id_solicitud)">
            <span class="material-icons" *ngIf="!cargando">file_upload</span>
            <mat-spinner *ngIf="cargando && idSolicitudSubiendoResponsiva === element.id_solicitud"
              diameter="20"></mat-spinner>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="nomColaborador">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
        <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
      </ng-container>

      <ng-container matColumnDef="nomPuesto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
        <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
      </ng-container>

      <ng-container matColumnDef="name_sucursalCol">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL DEL COLABORADOR </th>
        <td mat-cell *matCellDef="let element"> {{element.name_sucursalCol}} </td>
      </ng-container>

      <ng-container matColumnDef="status_solicitud">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL REGISTRO </th>
        <td mat-cell *matCellDef="let element"> {{element.status_solicitud}} </td>
      </ng-container>

      <ng-container matColumnDef="fechaRegistro">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE REGISTRO </th>
        <td mat-cell *matCellDef="let element"> {{element.fecha_planeada_act}} </td>
      </ng-container>

      <ng-container matColumnDef="fechaSolicitud">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE LA SOLICITUD</th>
        <td mat-cell *matCellDef="let element"> {{element.fechaSolicitud}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
      <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
    </table>

    <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" [length]="totalElementos"
      [pageSize]="opcionesPaginacion.cantidad" showFirstLastButtons (page)="paginar($event)"></mat-paginator>

  </div>
</div>